var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M26.94 6.6c1.204.331 2.153 1.306 2.475 2.543.585 2.242.585 6.92.585 6.92s0 4.677-.585 6.92c-.322 1.236-1.271 2.21-2.476 2.541-2.183.601-10.939.601-10.939.601s-8.756 0-10.94-.6c-1.204-.331-2.153-1.306-2.475-2.543C2 20.74 2 16.062 2 16.062s0-4.677.585-6.92c.322-1.236 1.27-2.21 2.476-2.541C7.244 6 16 6 16 6s8.756 0 10.94.6zm-13.565 5.526v8.75l7-4.375z",
    fill: "#1d1e1f",
    fillRule: "evenodd"
  })));
};
export default SvgYoutube;